import React from 'react'

const Leagues = () => {
  return <h2>Leagues Management</h2>
}

export default Leagues
